import React, { useState, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { deviceSize } from "../components/responsive";
import TopSectionBackgroundImg from "../img/3.jpeg";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";





const FormBox = styled.div`

max-width:700px;
width:95%;

margin:auto;


border-radius:30px;



`;






const TopSectionContainer = styled.div`
  width: 100%;
  height: 650px;
background:

radial-gradient(
circle at top,
#163b63,
#081a2f 45%,
#020617
);  background-position: 0px -150px;
  background-size: cover;

  @media only Screen and (max-width: 40em) {
    height: 550px;
  }
`;

const TopSec = styled.div`
  text-align: center;
  margin: auto;
`;

const Title = styled.h2`

font-size:clamp(2rem,5vw,3.5rem);

font-weight:900;

color:white;

margin-bottom:35px;

text-align:center;

position:relative;

text-shadow:
0 0 20px rgba(56,189,248,.5);

&::after{

content:"";

width:80px;
height:4px;

background:#38bdf8;

position:absolute;

bottom:-10px;
left:50%;

transform:translateX(-50%);

border-radius:30px;

box-shadow:
0 0 20px #38bdf8;

}

`;

const BackgroundFilter = styled.div`

width:100%;
height:100%;

background:

linear-gradient(
135deg,
rgba(2,6,23,.96),
rgba(8,26,47,.92)
);

display:flex;
flex-direction:column;

`;

const TopSectionInnerContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;
const Spinner = styled.span`
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
`;
const Button = styled.button`

width:100%;

padding:16px;

border:none;

border-radius:50px;

font-size:18px;

font-weight:900;

cursor:pointer;

color:white;

background:

linear-gradient(
135deg,
#0ea5e9,
#2563eb
);

box-shadow:
0 15px 35px rgba(37,99,235,.35);

transition:.3s;

display:flex;

align-items:center;

justify-content:center;

gap:10px;

&:hover{

transform:translateY(-3px);

box-shadow:
0 20px 45px rgba(37,99,235,.55);

}

&:disabled{

opacity:.8;

cursor:not-allowed;

}

`;
const Dots = styled.span`
  display: inline-flex;
  gap: 4px;
  align-items: center;
`;

const Dot = styled.span`
  width: 6px;
  height: 6px;
  background: white;
  border-radius: 50%;
  animation: bounce 1s infinite ease-in-out;

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }

  @keyframes bounce {
    0%, 80%, 100% {
      transform: scale(0.6);
      opacity: 0.4;
    }
    40% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;
const initialState = {
  name: "",
  phone: "",
  message: "",
};

export function TopSection(props) {
  const [{ name, phone, message }, setState] = useState(initialState);
const [loading, setLoading] = useState(false);
  const [captcha, setCaptcha] = useState(null);
  const recaptchaRef = useRef(null);

  const isMobile = useMediaQuery({ maxWidth: deviceSize.mobile });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const handleCaptchaChange = (value) => {
    setCaptcha(value);
  };

  const clearState = () => setState(initialState);
const handleSubmit = (e) => {
  e.preventDefault();

  if (!captcha) {
    alert("נא לאשר שאתה לא רובוט 🤖");
    return;
  }

  setLoading(true);

  emailjs
    .sendForm(
      "service_b9gmcqa",
      "template_6p4p52e",
      e.target,
      "JWHOQYzsIcnM9KDko"
    )
    .then(
      () => {
        alert("הודעה נשלחה בהצלחה, ניצור קשר בהקדם! תודה");

        clearState();
        setCaptcha(null);

        e.target.reset();

        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }

        setLoading(false);
      },
      (error) => {
        console.log(error.text);
        alert("הודעה לא נשלחה, נסה שנית");
        setLoading(false);
      }
    );
};
  return (
    <TopSectionContainer>
      <BackgroundFilter>
        {props.children}

        <TopSectionInnerContainer>
          <TopSec>
            <Title id="con">השאירו פרטים ונחזור אליכם בהקדם </Title>

<FormBox>
                <form onSubmit={handleSubmit}>
                <div className="row5">

          

                  <div className="col-md-6">
                    <input
                      style={{ textAlign: "right" }}
                      type="text"
                      name="name"
                      placeholder="שם"
                      className="form-control"
                      required
                      value={name}
                      onChange={handleChange}
                    />
                  </div>
                          <div className="col-md-6">
                    <input
                      style={{ textAlign: "right" }}
                      type="tel"
                      name="phone"
                      placeholder="טלפון"
                      className="form-control"
                      required
                      value={phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <textarea
                    style={{ textAlign: "right" }}
                    name="message"
                    rows="4"
                    placeholder="הודעה"
                    className="form-control"
                    required
                    value={message}
                    onChange={handleChange}
                  />
                </div>

<Button type="submit" disabled={loading}>
  {loading ? (
    <>
      שולח
      <Dots>
        <Dot />
        <Dot />
        <Dot />
      </Dots>
    </>
  ) : (
    "שלח"
  )}
</Button>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                >
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey="6LdxKdUdAAAAAGOyVnl1Fs8_GimLD8I8ELh4KDhW"
                    onChange={handleCaptchaChange}
                  />
                </div>
              </form>
</FormBox>
          </TopSec>
        </TopSectionInnerContainer>

     
      </BackgroundFilter>
    </TopSectionContainer>
  );
}